// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b760b521"};